import { openBlock, createElementBlock, mergeProps, renderSlot, createElementVNode, createCommentVNode } from 'vue';

const _hoisted_1 = ["width", "height", "fill", "transform"];
const _hoisted_2 = {
  key: 0
};
const _hoisted_3 = ["stroke"];
const _hoisted_4 = ["stroke"];
const _hoisted_5 = ["stroke"];
const _hoisted_6 = ["stroke"];
const _hoisted_7 = {
  key: 1
};
const _hoisted_8 = ["stroke"];
const _hoisted_9 = ["stroke"];
const _hoisted_10 = ["stroke"];
const _hoisted_11 = ["stroke"];
const _hoisted_12 = {
  key: 2
};
const _hoisted_13 = /*#__PURE__*/createElementVNode("path", {
  d: "M40,76H216a8,8,0,0,0,0-16H40a8,8,0,0,0,0,16Z"
}, null, -1);
const _hoisted_14 = /*#__PURE__*/createElementVNode("path", {
  d: "M64,100a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z"
}, null, -1);
const _hoisted_15 = /*#__PURE__*/createElementVNode("path", {
  d: "M216,140H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"
}, null, -1);
const _hoisted_16 = /*#__PURE__*/createElementVNode("path", {
  d: "M192,180H64a8,8,0,0,0,0,16H192a8,8,0,0,0,0-16Z"
}, null, -1);
const _hoisted_17 = [_hoisted_13, _hoisted_14, _hoisted_15, _hoisted_16];
const _hoisted_18 = {
  key: 3
};
const _hoisted_19 = ["stroke"];
const _hoisted_20 = ["stroke"];
const _hoisted_21 = ["stroke"];
const _hoisted_22 = ["stroke"];
const _hoisted_23 = {
  key: 4
};
const _hoisted_24 = ["stroke"];
const _hoisted_25 = ["stroke"];
const _hoisted_26 = ["stroke"];
const _hoisted_27 = ["stroke"];
const _hoisted_28 = {
  key: 5
};
const _hoisted_29 = ["stroke"];
const _hoisted_30 = ["stroke"];
const _hoisted_31 = ["stroke"];
const _hoisted_32 = ["stroke"];
function render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", mergeProps({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 256 256",
    width: _ctx.size,
    height: _ctx.size,
    fill: _ctx.color,
    transform: _ctx.mirrored ? 'scale(-1, 1)' : undefined
  }, _ctx.$attrs), [renderSlot(_ctx.$slots, "default"), _ctx.weight === 'bold' ? (openBlock(), createElementBlock("g", _hoisted_2, [createElementVNode("line", {
    x1: "40",
    y1: "68",
    x2: "216",
    y2: "68",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "24"
  }, null, 8, _hoisted_3), createElementVNode("line", {
    x1: "64",
    y1: "108",
    x2: "192",
    y2: "108",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "24"
  }, null, 8, _hoisted_4), createElementVNode("line", {
    x1: "40",
    y1: "148",
    x2: "216",
    y2: "148",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "24"
  }, null, 8, _hoisted_5), createElementVNode("line", {
    x1: "64",
    y1: "188",
    x2: "192",
    y2: "188",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "24"
  }, null, 8, _hoisted_6)])) : _ctx.weight === 'duotone' ? (openBlock(), createElementBlock("g", _hoisted_7, [createElementVNode("line", {
    x1: "40",
    y1: "68",
    x2: "216",
    y2: "68",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "16"
  }, null, 8, _hoisted_8), createElementVNode("line", {
    x1: "64",
    y1: "108",
    x2: "192",
    y2: "108",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "16"
  }, null, 8, _hoisted_9), createElementVNode("line", {
    x1: "40",
    y1: "148",
    x2: "216",
    y2: "148",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "16"
  }, null, 8, _hoisted_10), createElementVNode("line", {
    x1: "64",
    y1: "188",
    x2: "192",
    y2: "188",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "16"
  }, null, 8, _hoisted_11)])) : _ctx.weight === 'fill' ? (openBlock(), createElementBlock("g", _hoisted_12, _hoisted_17)) : _ctx.weight === 'light' ? (openBlock(), createElementBlock("g", _hoisted_18, [createElementVNode("line", {
    x1: "40",
    y1: "68",
    x2: "216",
    y2: "68",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "12"
  }, null, 8, _hoisted_19), createElementVNode("line", {
    x1: "64",
    y1: "108",
    x2: "192",
    y2: "108",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "12"
  }, null, 8, _hoisted_20), createElementVNode("line", {
    x1: "40",
    y1: "148",
    x2: "216",
    y2: "148",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "12"
  }, null, 8, _hoisted_21), createElementVNode("line", {
    x1: "64",
    y1: "188",
    x2: "192",
    y2: "188",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "12"
  }, null, 8, _hoisted_22)])) : _ctx.weight === 'thin' ? (openBlock(), createElementBlock("g", _hoisted_23, [createElementVNode("line", {
    x1: "40",
    y1: "68",
    x2: "216",
    y2: "68",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "8"
  }, null, 8, _hoisted_24), createElementVNode("line", {
    x1: "64",
    y1: "108",
    x2: "192",
    y2: "108",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "8"
  }, null, 8, _hoisted_25), createElementVNode("line", {
    x1: "40",
    y1: "148",
    x2: "216",
    y2: "148",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "8"
  }, null, 8, _hoisted_26), createElementVNode("line", {
    x1: "64",
    y1: "188",
    x2: "192",
    y2: "188",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "8"
  }, null, 8, _hoisted_27)])) : _ctx.weight === 'regular' ? (openBlock(), createElementBlock("g", _hoisted_28, [createElementVNode("line", {
    x1: "40",
    y1: "68",
    x2: "216",
    y2: "68",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "16"
  }, null, 8, _hoisted_29), createElementVNode("line", {
    x1: "64",
    y1: "108",
    x2: "192",
    y2: "108",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "16"
  }, null, 8, _hoisted_30), createElementVNode("line", {
    x1: "40",
    y1: "148",
    x2: "216",
    y2: "148",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "16"
  }, null, 8, _hoisted_31), createElementVNode("line", {
    x1: "64",
    y1: "188",
    x2: "192",
    y2: "188",
    fill: "none",
    stroke: _ctx.color,
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    "stroke-width": "16"
  }, null, 8, _hoisted_32)])) : createCommentVNode("", true)], 16, _hoisted_1);
}

export { render };
